import { FollowUpQuestionSuggestion } from '@/lib/models';

/* --------------------------------------- */
/* Event models */
/* --------------------------------------- */
type MessageEventDataBase = {
	seq: number;
};

type MessageEventDataAnswer = MessageEventDataBase & {
	type: 'answer';
	content: string;
};

type MessageEventDataTypeOfData = MessageEventDataBase & {
	type: 'typeOfData';
	content: string;
};

type MessageEventDataDone = MessageEventDataBase & {
	type: 'done';
};

export type MessageEventData = MessageEventDataAnswer | MessageEventDataTypeOfData | MessageEventDataDone;

/* --------------------------------------- */
/* Parsed payload models */
/* --------------------------------------- */
export interface MessageEventDataSuggestionsPayload {
	suggestions: FollowUpQuestionSuggestion[];
}

export interface MessageEventDataPostAnswerPayload {
	conversationQueryId: string;
	hasRating: boolean;
}

/* --------------------------------------- */
/* Type checkers */
/* --------------------------------------- */
export function messageDataIsAnswer(messageData: MessageEventData): messageData is MessageEventDataAnswer {
	return messageData.type === 'answer';
}

export function messageDataIsTypeOfData(messageData: MessageEventData): messageData is MessageEventDataTypeOfData {
	return messageData.type === 'typeOfData';
}

export function messageDataIsDone(messageData: MessageEventData): messageData is MessageEventDataDone {
	return messageData.type === 'done';
}
